import { Stack } from '@mui/material'
import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'

export default function ValuationIncomePageLoading() {
    return (
        <PageGridContainer>
            <PageGridItem columnSpan={3} columnSpanXs={2}>
                <LoadingSkeleton variant="rounded" height="242px" />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={2}>
                <LoadingSkeleton variant="rounded" height="242px" />
            </PageGridItem>

            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <LoadingSkeleton variant="rounded" height="138px" />
            </PageGridItem>

            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <LoadingSkeleton variant="rounded" height="324px" />
            </PageGridItem>

            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="row" gap={tokens.SizingSpacing300}>
                    <LoadingSkeleton variant="rounded" height="109px" width="100%" />
                    <LoadingSkeleton variant="rounded" height="109px" width="100%" />
                    <LoadingSkeleton variant="rounded" height="109px" width="100%" />
                    <LoadingSkeleton variant="rounded" height="109px" width="100%" />
                </Stack>
            </PageGridItem>

            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <LoadingSkeleton variant="rounded" height="324px" />
            </PageGridItem>
        </PageGridContainer>
    )
}
